import { defineStore } from 'pinia'
import httpClient from '@/api/httpClient'
import { useMessagesStore } from '@/stores/messages'

const sortLockedStories = (lockedStories) => {
  return [...lockedStories].sort((left, right) => {
    const leftTime = left.locked_at ? new Date(left.locked_at).getTime() : Number.MAX_SAFE_INTEGER
    const rightTime = right.locked_at ? new Date(right.locked_at).getTime() : Number.MAX_SAFE_INTEGER

    if (leftTime !== rightTime) return leftTime - rightTime
    return left.id - right.id
  })
}

export const useLockedStoriesStore = defineStore('lockedStories', {
  state: () => ({
    lockedStories: []
  }),

  actions: {
    async fetch() {
      return httpClient.get('/api/internal/locked_stories')
        .then(({ data }) => {
          this.lockedStories = sortLockedStories(data.locked_stories || [])
        })
        .catch((err) => {
          useMessagesStore().smartAdd(err)
          throw err
        })
    },

    applyLockEvent(story) {
      if (!story?.id) return

      if (!story.locker) {
        this.lockedStories = this.lockedStories.filter(lockedStory => lockedStory.id !== story.id)
        return
      }

      const existing = this.lockedStories.find(lockedStory => lockedStory.id === story.id)
      const nextStory = existing ? { ...existing, ...story } : story

      this.lockedStories = sortLockedStories([
        ...this.lockedStories.filter(lockedStory => lockedStory.id !== story.id),
        nextStory
      ])
    }
  }
})